module.exports = __webpack_public_path__ + "img/pic17.4b82631e.png";